import { useParentDashboardContextContext } from '../../../context/ParentDashboardContext';
import { useSafeTranslation } from '../../../hooks/useSafeTranslation';
import { ConsumerDto } from '../../../shared/type/parentDashboardContext.type';
import CustomChakraButton from '../../CustomChakraButton/CustomChakraButton';

type ChildOverviewProps = {
  child: ConsumerDto;
  showBalance?: boolean;
  showTenantName?: boolean;
  consumerId: number | null;
  showMoreDetails?: boolean;
  onEditClick?: (kid: ConsumerDto) => void;
};

export const ChildOverview = ({
  child,
  showBalance,
  showTenantName,
  consumerId,
  showMoreDetails,
  onEditClick
}: ChildOverviewProps) => {
  const { t } = useSafeTranslation();
  const { parentDashboardContext } = useParentDashboardContextContext();

  const findTenantNameByConsumerId = (consumerId: number): string | null => {
    const tenant = parentDashboardContext?.tenants.find((tenant) =>
      tenant.consumers.some((consumer) => consumer.consumerDto.id === consumerId)
    );
    return tenant ? tenant.tenantName : null;
  };

  return (
    <div className="ParentAssignedAccounts__kidTab w-full flex flex-col border-b box-border border-brand-200 lg:border-transparent gap-spacing-xl lg:gap-0 p-spacing-xl lg:pt-spacing-xl lg:pb-spacing-xl lg:px-spacing-3xl lg:rounded-xl">
      <div className="flex items-center justify-between">
        <div
          className="flex flex-col gap-spacing-xl lg:gap-0 lg:flex-row lg:justify-between"
          style={{ width: !onEditClick ? '100%' : 'auto' }}>
          <div>
            <p className="font-semibold text-grayLight-700" style={{ fontSize: '18px' }}>
              {child.firstName} {child.lastName}
            </p>
          </div>
          {showBalance && (
            <div className="flex flex-col items-start lg:items-end gap-spacing-xs">
              <p className="text-sm font-normal text-grayLight-600">
                {t('parent_assigned_accounts.balance')}
              </p>
              <p className="font-semibold text-grayLight-600" style={{ fontSize: '18px' }}>
                {child.saldo}
              </p>
            </div>
          )}
        </div>
        {!!onEditClick && (
          <CustomChakraButton
            hierarchy="linkGray"
            icon="edit"
            iconPosition="left"
            size="md"
            buttonProps={{
              type: 'button',
              onClick: () => {
                onEditClick?.(child);
              }
            }}>
            {t('parent_assigned_accounts.edit')}
          </CustomChakraButton>
        )}
      </div>
      <div className="flex lg:flex-row flex-col gap-spacing-xl mt-2">
        <div className="flex flex-col">
          <p className="text-sm font-normal text-grayLight-600">
            {t('parent_assigned_accounts.class')}
          </p>
          <p className="font-semibold text-grayLight-600" style={{ fontSize: '18px' }}>
            {child.organisationUnitName}
          </p>
        </div>
        {showTenantName && (
          <div className="flex flex-col">
            <p className="text-sm font-normal text-grayLight-600">
              {' '}
              {t('parent_assigned_accounts.school')}
            </p>
            <p className="font-semibold text-grayLight-600" style={{ fontSize: '18px' }}>
              {findTenantNameByConsumerId(consumerId || 0) || '-'}
            </p>
          </div>
        )}
      </div>
      {showMoreDetails && (
        <>
          <div className="mt-2 flex flex-col gap-1">
            <p className="text-sm font-normal text-grayLight-600">
              {t('parent_assigned_accounts.identifier')}
            </p>
            <p className="font-semibold text-grayLight-600" style={{ fontSize: '18px' }}>
              {child.cardNumber}
            </p>
          </div>
          <div className="mt-2 gap-1 flex flex-col">
            <p className="text-sm font-normal text-grayLight-600">
              {t('parent_assigned_accounts.remarks')}
            </p>
            <p className="font-semibold text-grayLight-600" style={{ fontSize: '18px' }}>
              {child.remarks}
            </p>
          </div>
        </>
      )}
    </div>
  );
};
